import { Inject, Injectable } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {
  constructor(private router: Router, @Inject('FIREBASE_AUTH') private auth: Auth) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = await firstValueFrom(authState(this.auth));
    if (!user) {
      return true;
    }

    // not logged in so redirect to home
    this.router.navigate(['/']);
    return false;
  }
}
